import { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { DropdownSelect } from '../dropdown-select/DropdownSelect';
import { FinalCustomerTagsService } from '../../services/finalCustomerTagsService';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';

export const SelectTags = ({
  value,
  onChange,
  multiple = false,
  disabled,
  getTags = FinalCustomerTagsService.getTags,
}) => {
  const { translate: t } = useDictionaryTranslation();
  const [tags, setTags] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const selectTag = (item) => {
    if (multiple) {
      onChange(item);
      return;
    }
    let selectedOption;
    if (item) selectedOption = tags.find((s) => s._id === item.value);
    onChange(selectedOption);
  };

  const getTagsItems = useCallback(
    async (search) => {
      setIsLoading(true);
      try {
        const { finalCustomerTags } = await getTags({ search });
        setTags(finalCustomerTags);
      } catch (error) {
        setTags([]);
      } finally {
        setIsLoading(false);
      }
    },
    [getTags],
  );

  const getOptionData = useCallback((tag) => {
    return {
      value: tag._id,
      label: tag.name,
    };
  }, []);

  return (
    <DropdownSelect
      placeholderText={t('tagsPlaceholder')}
      isLoading={isLoading}
      onChange={selectTag}
      options={tags}
      value={value}
      onSearch={getTagsItems}
      getOptionData={getOptionData}
      multiple={multiple}
      disabled={disabled}
    />
  );
};

SelectTags.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.shape({
      _id: PropTypes.string,
      name: PropTypes.string,
    }),
    PropTypes.array,
  ]),
  onChange: PropTypes.func,
  multiple: PropTypes.bool,
  getTags: PropTypes.func,
  disabled: PropTypes.bool,
};

// SelectTags.defaultProps = {
//   getTags: FinalCustomerTagsService.getTags,
// };
